import React, { useState, useContext, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Typography,
  useTheme,
  Tooltip,
} from "@mui/material";
import { AuthContext } from "../../FirebaseAuth";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import LanguageIcon from "@mui/icons-material/Language";
import WebIcon from "@mui/icons-material/Web";
import MenuBookIcon from "@mui/icons-material/MenuBook";

import { Firestore } from "../../../components/FirebaseAuth/firebase";
import { isKWALLAdmin, isAdmin } from "../../../utils/index";
import { getDoc, doc } from "firebase/firestore";

const AccountMenu = () => {
  const theme = useTheme();

  // Styling for selected and non-selected items
  const selectedStyle = {
    color: theme.palette.primary.main,
  };

  const textDecorationStyle = {
    textDecoration: "none",
  };

  const initialUserState = {
    isLoading: true,
    data: null,
  };
  const [userData, setUserData] = useState(initialUserState);
  const { accountId } = useParams();
  const { pathname } = useLocation();
  const { authUser, isMyTemplate } = useContext(AuthContext);
  const { isDrawerOpen } = useContext(AuthContext);

  async function getUserData() {
    try {
      // const refUser = await Firestore.collection("users")
      //   .doc(authUser.user.uid)
      //   .get();
      // const userData = await refUser.data();

      const userDocRef = doc(Firestore, "users", authUser.user.uid);
      const refUser = await getDoc(userDocRef);
      const userData = await refUser.data();
      setUserData({
        data: userData,
        isLoading: false,
      });
    } catch (ex) {
      console.log("___ ex", ex);
    }
  }

  useEffect(() => {
    getUserData();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    document.querySelectorAll(".c-sidebar").forEach((element) => {
      window.coreui.Sidebar._sidebarInterface(element);
    });
  });

  if (userData.isLoading) return null;

  // Determine if menu is in collapsed state
  const collapsed = !isDrawerOpen;

  // Common styles for icons
  const iconStyle = {
    fontSize: "1.4rem",
    color: theme.palette.text.secondary,
  };

  // Helper to render menu items with proper styling
  const renderMenuItem = (to, icon, label, isActive) => {
    const active = isActive !== undefined ? isActive : pathname.includes(to);

    return (
      <Link to={to} style={textDecorationStyle}>
        <ListItem
          button
          selected={active}
          sx={{
            borderRadius: 2,
            mb: 0.5,
            py: 1,
            px: collapsed ? 1 : 2,
            "&.Mui-selected": {
              bgcolor: "rgba(25, 118, 210, 0.08)",
            },
            "&:hover": {
              bgcolor: "rgba(25, 118, 210, 0.04)",
            },
          }}
        >
          <Tooltip title={collapsed ? label : ""} placement="right" arrow>
            <ListItemIcon sx={{ minWidth: collapsed ? 36 : 40 }}>
              {React.cloneElement(icon, {
                style: active ? selectedStyle : iconStyle,
              })}
            </ListItemIcon>
          </Tooltip>

          {!collapsed && (
            <ListItemText
              primary={
                <Typography
                  variant="body2"
                  color="textPrimary"
                  sx={{
                    fontWeight: active ? 600 : 400,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    color: active
                      ? theme.palette.primary.main
                      : "rgb(33, 37, 41)",
                  }}
                >
                  {label}
                </Typography>
              }
            />
          )}
        </ListItem>
      </Link>
    );
  };

  return (
    <List
      component="nav"
      sx={{
        p: 1,
        width: "100%",
        "& .MuiListItemButton-root": {
          borderRadius: 2,
          mb: 0.5,
        },
        mt: { xs: "60px", sm: "60px", md: 0 },
      }}
    >
      {renderMenuItem(
        "/",
        <DashboardIcon />,
        "Home",
        !pathname.includes("/account")
      )}
      {renderMenuItem(`/account/${accountId}/sites`, <LanguageIcon />, "Sites")}

      {(isAdmin(userData.data.role) || isKWALLAdmin(userData.data.role)) &&
        renderMenuItem(
          `/account/${accountId}/also-templates`,
          <MenuBookIcon />,
          "Templates"
        )}

      {(isAdmin(userData.data.role) || isKWALLAdmin(userData.data.role)) &&
        isMyTemplate.isMenuOpen &&
        isMyTemplate.status &&
        renderMenuItem(
          `/account/${accountId}/templates`,
          <WebIcon />,
          "My Templates"
        )}

      {renderMenuItem(
        `/account/${accountId}/users`,
        <PeopleAltIcon />,
        "Users"
      )}
    </List>
  );
};

export default AccountMenu;
